/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  DigitalClockPlugin,
  IDigitalClockPluginMethods,
  StaticContentPlugin,
  IStaticContentPluginMethods,
  ShelvesPlugin,
  IShelvesPluginMethods,
  LoadingContentPlugin,
  ILoadingContentPluginMethods,
  ErrorContentPlugin,
  IErrorContentPluginMethods,
} from './plugins';

export type TAgent = IStaticContentPluginMethods &
  ILoadingContentPluginMethods &
  IErrorContentPluginMethods &
  IDigitalClockPluginMethods &
  IShelvesPluginMethods;

const getPlugins = () => {
  return [
    new StaticContentPlugin(),
    new ErrorContentPlugin(),
    new LoadingContentPlugin(),
    //Business logic plugins !
    new DigitalClockPlugin(),
    new ShelvesPlugin(),
  ];
};

export const getAgent = () => {
  return createAgent<TAgent>({
    plugins: getPlugins(),
  });
};
